document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.quantity-minus, .quantity-plus').forEach(function(button) {
      button.addEventListener('click', function() {
        var inputId = this.getAttribute('data-input-id');
        var input = document.getElementById(inputId);
        var currentValue = parseInt(input.value) || 1;
        if (this.classList.contains('quantity-minus')) {
          input.value = currentValue - 1 > 1 ? currentValue - 1 : 1;
        } else {
          input.value = currentValue + 1;
        }
      });
    });
  });